import { AmenityIcon, groupByCategory } from "@/components/property/amenityMeta";

/**
 * Read-only display of a property's amenities, grouped by category.
 * `amenities` = array from GET /properties/{id}/amenities (active only).
 */
export default function AmenityDisplay({ amenities = [], testid = "amenity-display" }) {
  if (!amenities.length) {
    return (
      <p className="text-sm text-muted-foreground" data-testid={`${testid}-empty`}>
        Belum ada fasilitas yang ditambahkan.
      </p>
    );
  }
  const groups = groupByCategory(amenities);
  return (
    <div className="space-y-4" data-testid={testid}>
      {groups.map((g) => (
        <div key={g.category}>
          <p className="text-xs font-bold uppercase tracking-[0.15em] text-muted-foreground mb-2">{g.label}</p>
          <div className="flex flex-wrap gap-2">
            {g.items.map((a) => (
              <span
                key={a.id}
                data-testid={`amenity-badge-${a.slug}`}
                className="inline-flex items-center gap-2 rounded-full border border-border bg-secondary/40 px-3.5 py-1.5 text-sm text-foreground"
              >
                <AmenityIcon name={a.icon} size={14} className="text-primary" />
                {a.name}
              </span>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
